import { HttpParams } from '@angular/common/http';
import { Component, ElementRef, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { faLink } from '@fortawesome/free-solid-svg-icons';
import { update } from 'lodash';
import { Organization } from 'src/app/shared/models/organization.model';
import { SharedService } from 'src/app/shared/shared.service';
import { Course, CoursesService, CourseType } from './courses.service';
import { ToastService } from 'src/app/shared/toast/toast.service';

@Component({
    selector: 'app-update-courses',
    templateUrl: './update-courses.component.html',
    styleUrls: ['./update-courses.component.css'],
    standalone: false
})
export class UpdateCoursesComponent implements OnInit {

  @ViewChild('sectionToScroll') sectionToScroll: ElementRef;
  @ViewChild('errorTemplate') errorTemplate: TemplateRef<any>;

  public currentOrganizationId: number;
  public courseTypes: CourseType[] = [];
  public currentOrgLanguage = 'it';
  public languageToString = ({
    'it': 'Italian - IT-it',
    'de': 'German - DE-de',
    'en': 'English - EN-en',
  });
  public icons: { [name: string]: any } = {
    'faLink': faLink
  };
  public formGroup: FormGroup;
  public updateCourse = false;
  public courses: Course[] = [];
  public orgTypeId: number;

  private _organization: Organization;

  constructor(private _activatedRoute: ActivatedRoute, private _router: Router, private _coursesService: CoursesService,
    private _formBuilder: FormBuilder, private _sharedService: SharedService, private _toastService: ToastService) {
    this.formGroup = this._formBuilder.group({
      'id': [''],
      'name_en': [''],
      'name_it': [''],
      'name_de': [''],
      'description_en': [''],
      'description_it': [''],
      'description_de': [''],
      'courseTypeId': [],
    });

    this._toastService.remove();
  }

  ngOnInit(): void {
    const urlPramas = this._activatedRoute.snapshot.params;
    if (!urlPramas.orgId) {
      this._router.navigate(['/']);
    }

    // tslint:disable-next-line:radix
    this.orgTypeId = parseInt(localStorage.getItem('orgId'));
    this.currentOrganizationId = urlPramas.orgId;

    this._sharedService.getOrganization(urlPramas.orgId).subscribe(requestResult => {
      this._organization = requestResult;
      this._sharedService.organizationNameSubject.next({ 'de': this._organization.name_de, 'it': this._organization.name_it });
    }, requestError => {
      console.log(requestError);
    });

    this._coursesService.getAllCourseTypes().subscribe(result => {
      this.courseTypes = result;
    });

    this._coursesService.getCoursesByOrgId(this.currentOrganizationId).subscribe();
    this._coursesService.courses.subscribe(result => {
      this.courses = [];
      this.courses = result;
    });

    this._coursesService.courseDeleteIndex.subscribe(index => {
      this._coursesService.deleteCourseById(index).subscribe(() => { });
    });

    this._coursesService.courseUpdateIndex.subscribe(index => {
      const updateCourse = { ... this.courses[index] };
      if (this.orgTypeId === 1) {
        updateCourse['courseTypeId'] = updateCourse.courseType.id;
        delete updateCourse.courseType;
      }
      this.formGroup.patchValue(updateCourse);
      this.updateCourse = true;
      this.sectionToScroll.nativeElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });

  }

  onFormSubmit() {

    const course = this.formGroup.value;
    const courseTypeId: String = course.courseTypeId;
    const name_it: String = course.name_it;
    const name_de: String = course.name_de;
    const name_en: String = course.name_en;


    if (((name_it) || (name_de) || (name_en)) && courseTypeId && this.orgTypeId === 1) {
      this._coursesService.submitCourse(this.currentOrganizationId.toString(), this.formGroup.value, this.orgTypeId).subscribe(result => {
        this.updateCourse = false;
        this.formGroup.reset();
      });
    } else if (this.orgTypeId === 2) {
      this._coursesService.submitCourse(this.currentOrganizationId.toString(), this.formGroup.value, this.orgTypeId).subscribe(result => {
        this.updateCourse = false;
        this.formGroup.reset();
      });
    } else {
      this._toastService.show('GENERAL.TOAST.errorMissingMandatory', {
        classname: 'bg-danger text-light',
        delay: 3000,
        autohide: true,
      });
    }
  }
}
